import React from 'react';
import SPBreadcrumb from "../../../components/base/SPBreadcrumb";
import SPStoreRatingForm from "../../../components/carRental/storeManagement/SPStoreRating/SPStoreRatingForm";
import SPStoreRatingTotal from "../../../components/carRental/storeManagement/SPStoreRating/SPStoreRatingTotal";
import SPStoreRatingTabs from "../../../components/carRental/storeManagement/SPStoreRating/SpStoreRatingTabs";

interface PagePropsType {
    enums?: any;
    permission?: any;
}

const StoreRating: React.FC<PagePropsType> = (props) => {
    const { permission } = props || {};

    const errorContent = '数据获取失败，请联系平台客服或商务协助处理'

    return (
        <>
            <SPBreadcrumb title="门店评分" />
            <SPStoreRatingForm />
            <SPStoreRatingTotal errorContent={errorContent}/>
            <SPStoreRatingTabs errorContent={errorContent} permission={permission}/>
        </>
    );
};

export default StoreRating;